import React, { useState } from 'react';
import { Menu, X, ShoppingBag, Search } from 'lucide-react';

const Navigation = ({ onSizeGuideClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="navigation-header">
      <div className="container" style={{ padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/" className="navigation-logo">SOLENNE</a>
          
          <nav className={`navigation-menu ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
            <a href="#collection" className="navigation-link">Collection</a>
            <a href="#craftsmanship" className="navigation-link">Craftsmanship</a>
            <button onClick={onSizeGuideClick} className="navigation-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Size Guide</button>
            <a href="#testimonials" className="navigation-link">Reviews</a>
          </nav>

          <div className="navigation-utilities">
            <button className="btn-icon" aria-label="Search">
              <Search size={20} />
            </button>
            <button className="btn-icon" aria-label="Shopping Bag">
              <ShoppingBag size={20} />
            </button>
            <button 
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle Menu"
              style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'none' }}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
